import { isContactPersonMainFieldsFilled } from '../elements/CustomerModal/utils/contactPersons/contactPersonValidation'
import { ContactPerson } from '../types/contactPerson'

export const getContactPersonsWithoutEmptyPrimaryContact = (contactPersons: ContactPerson[]): ContactPerson[] => {
  return contactPersons.filter(
    (contact) =>
      !(contact.isPrimary && !isContactPersonMainFieldsFilled(contact.email, contact.firstName, contact.lastName)),
  )
}
